<script setup lang="ts"></script>

<template>
  <div class="bg-slate-600 w-[500px] h-[500px]">
    DEFAULT LAYOUT
    <router-view />
  </div>
</template>
